<template>
  <div
    class="modal fade"
    id="switchModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalCenterTitle">
            Service Switch
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="service">Service</label>
              <select class="form-control" v-model="provider.service">
                <option value="">Select a Service</option>
                <option
                  v-for="product in utils.products"
                  :key="product"
                  :value="product"
                >
                  {{ product }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="service">Status</label>
              <select class="form-control" v-model="provider.status">
                <option value="">Select a Status</option>
                <option value="ON">ON</option>
                <option value="OFF">OFF</option>
              </select>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button type="button" class="btn btn-primary" @click="updateProvider">
            <div
              class="spinner-grow"
              role="status"
              v-if="loading.show === true"
            ></div>
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../../store/axios";
export default {
  data() {
    return {
      provider: {
        service: "",
        status: "",
      },
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions(["setLoading", "setNotification"]),
    updateProvider() {
      this.$confirm(
        `Switch ${this.provider.status} ${this.provider.service} ?`,
      ).then(async () => {
        try {
          this.setLoading(true);
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/admin/changeProviderStatus`,
            this.provider,
          );
          const { message } = res.data;

          this.setNotification({
            type: "success",
            message,
          });
        } catch (err) {
          if (err.response) {
            const { data } = err.response;
            this.setNotification({
              type: "danger",
              message: data.message || "Unable to Change Provider",
            });
          } else {
            console.log(err);
            this.setNotification({
              type: "danger",
              message: "Unable to Change Provider",
            });
          }
        }
        this.setLoading(false);
      });
    },
  },
  mounted() {
    this.provider = {
      service: "",
      provider: "",
    };
  },
};
</script>
<style scoped>
.p22 {
  padding-top: 15%;
}
</style>
